import { Squad } from '../../../types';

/**
 * Phase 1 helper: reliably read a squad's curriculum id with a safe default.
 * - Defaults to 'music' for any missing or unknown values to preserve
 *   backward compatibility until multi-curriculum is fully enabled.
 */
export function getSquadCurriculumId(squad?: Pick<Squad, 'curriculumId'> | null): string {
  const id = squad?.curriculumId?.trim();
  return id && id.length > 0 ? id : 'music';
}

/**
 * Treat the base and seasonal music curricula as music experiences.
 */
export function isMusicCurriculum(squad?: Pick<Squad, 'curriculumId'> | null): boolean {
  return getSquadCurriculumId(squad).toLowerCase().startsWith('music');
}

/** Demo squads always use the modern classroom dashboard, even on legacy music records. */
export function isDemoExperienceSquad(
  squad?: Pick<Squad, 'scheduleKind' | 'singleDayType' | 'demoExperienceId'> | null
): boolean {
  if (!squad) return false;
  return Boolean(squad.demoExperienceId)
    || (squad.scheduleKind === 'single_day' && squad.singleDayType === 'demo');
}

export function usesLegacyMusicDashboard(
  squad?: Pick<Squad, 'curriculumId' | 'scheduleKind' | 'singleDayType' | 'demoExperienceId' | 'sessionPlan'> | null
): boolean {
  return isMusicCurriculum(squad) && !isDemoExperienceSquad(squad) && !squad?.sessionPlan?.slots.some(slot => slot.curriculumId);
}
